import React, { useState } from 'react'
import Cookies from 'universal-cookie'

const Footer = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const cookies = new Cookies()

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen)
    cookies.set('show-how-it-works', 'true')
  }

  const closeModal = e => {
    if (e.target.id === 'modal') {
      setModalIsOpen(false)
      cookies.set('show-how-it-works', 'true')
    }
  }

  const modalContent = (
    <div
      id="modal"
      onClick={closeModal}
      className={`modal ${modalIsOpen ? 'show-modal' : ''}`}
    >
      <div className="rounded-2xl max-w-[680px] w-[92vw] p-6 max-h-[90vh] overflow-auto border border-[#2a2d36] bg-[#171a21] text-[#f8ffe8] shadow-[0_0_18px_rgba(245,0,255,0.12)]">
        <h1 className="text-center text-2xl font-bold mb-2 tracking-tight">
          terms
        </h1>

        <div className="space-y-2 text-sm text-[#f8ffe8]/80">
          <p>
            <strong>&bull; terms of use</strong>
          </p>
          <p className="text-[#f8ffe8]/70 text-xs">
            welcome to hotcurves.fun ("the platform"). by accessing or using our
            services, you agree to be bound by these terms.
          </p>
          <p className="text-[#f8ffe8]/70 text-xs">
            <strong>1. platform services:</strong> we offer tools for coins
            creation, trading, and analytics. use at your own discretion.
          </p>
          <p className="text-[#f8ffe8]/70 text-xs">
            <strong>2. eligibility:</strong> users must be 18+ and legally
            allowed to use such platforms.
          </p>
          <p className="text-[#f8ffe8]/70 text-xs">
            <strong>3. user conduct:</strong> illegal activities are strictly
            prohibited.
          </p>
          <p className="text-[#f8ffe8]/70 text-xs">
            <strong>4. intellectual property:</strong> all content belongs to
            hotcurves.fun or its licensors. do not copy or misuse without
            consent.
          </p>
          <p className="text-[#f8ffe8]/70 text-xs">
            <strong>5. liability:</strong> we’re not responsible for loss,
            damages, or misuse. use at your own risk.
          </p>
          <p className="text-[#f8ffe8]/70 text-xs">
            <strong>6. changes:</strong> we may update these terms anytime.
            continued use signifies acceptance.
          </p>
          <p className="text-[#f8ffe8]/60 italic text-xs">
            crypto is risky. always dyor.
          </p>
        </div>

        <hr className="my-6 border-gray-300" />

        <div className="text-sm space-y-2 text-[#f8ffe8]/80">
          <h2 className="text-center text-lg font-bold mb-2">how it works</h2>
          <ul className="list-disc list-inside">
            <li>hotcurves.fun allows anyone to create coins.</li>
            <li>
              all coins are fair-launch — everyone gets equal access at launch.
            </li>
            <li>step 1: pick a coin you like.</li>
            <li>step 2: buy the coin on the bonding curve.</li>
            <li>step 3: sell at any time to lock in your profits or losses.</li>
          </ul>
          <p className="text-center italic text-xs text-[#f8ffe8]/60 mt-2">
            by clicking below, you agree to the terms and certify you are over
            18.
          </p>
        </div>

        <div className="text-center mt-6">
          <button
            onClick={toggleModal}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-xl border border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8] hover:bg-[#2a2d36] hover:border-[#a135bb] text-sm transition-all hk-buzz"
          >
            i'm ready to pump
          </button>
        </div>
      </div>
    </div>
  )

  return (
    <footer className="bg-[#171a21] border-t border-[#2a2d36] py-5 text-[#f8ffe8] text-sm relative">
      <style>{`
        .modal {
          opacity: 0;
          visibility: hidden;
          position: fixed;
          inset: 0;
          background-color: rgba(12, 14, 18, 0.75);
          display: flex;
          justify-content: center;
          align-items: center;
          transition: opacity 0.25s ease, visibility 0.25s ease;
          z-index: 70;
        }

        .show-modal {
          opacity: 1;
          visibility: visible;
        }
      `}</style>
      {modalContent}
      <div className="max-w-7xl mx-auto px-6 flex flex-row-reverse justify-between items-center text-sm text-[#f8ffe8]/80">
        <p className="text-xs text-[#f8ffe8]/50">
          &copy; {new Date().getFullYear()} hotcurves.fun
        </p>
        <div className="flex items-center space-x-2 text-sm text-[#f8ffe8]/80">
          <a
            href="https://www.hotkeyswap.com"
            className="text-[#f8ffe8]/80 hover:text-white hover:underline underline-offset-4"
          >
            hotkeyswap
          </a>
          <span className="text-[#f8ffe8]/30">|</span>
          <span
            className="cursor-pointer underline underline-offset-4 hover:text-white"
            onClick={toggleModal}
          >
            terms
          </span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
